import { configValue } from 'utils/config';

import {
  imageAPngMimeType,
  imageBmpMimeType,
  imageGifMimeType,
  imageJpegMimeType,
  imagePJpegMimeType,
  imagePngMimeType,
  imageSvgMimeType,
  imageTiffMimeType,
  imageWebpMimeType,
} from './image/imageMimeTypes';

const optimizations = ['cache=expiry:31536000', 'compress', 'no_metadata'].join(
  '/',
);

type Props = {
  handle: string;
  transform?: string;
  format?: string;
  mimetype?: string;
  insecureSVG?: boolean;
};

export function imageUrl({
  handle,
  transform,
  format,
  mimetype,
  insecureSVG,
}: Props) {
  const mockValue = configValue('filestack', 'mock');
  const secure = insecureSVG ? 'false' : 'true';

  if (mockValue === 'storybook') {
    return `/storybook-fake/${handle}`;
  }

  const baseUrl = mockValue
    ? '/lolz/image'
    : 'https://process.filestackapi.com';

  // transforms are not supported for svg, but secure flag is
  // https://www.filestack.com/docs/api/processing/#file-conversions
  if (mimetype?.includes('image/svg')) {
    return `${baseUrl}/output=secure:${secure}/${optimizations}/${handle}`;
  }

  return `${baseUrl}/${transform ? `${transform}/` : ''}${
    format ? `output=format:${format}/` : ''
  }${optimizations}/${handle}`;
}

export function imageSizeUrl({ handle }: { handle: string }) {
  return configValue('filestack', 'mock')
    ? '/lolz/image-size'
    : `https://cdn.filestackcontent.com/imagesize/${handle}`;
}

export const filestackSupportedMimeTypes = [
  imageAPngMimeType,
  imageBmpMimeType,
  imageGifMimeType,
  imageJpegMimeType,
  imagePJpegMimeType,
  imagePngMimeType,
  imageSvgMimeType,
  imageTiffMimeType,
  imageWebpMimeType,
  // Filestack does not support icons
  // imageIconMimeType,
];
